import { Link } from 'react-router-dom'
import Card from '../templates/ui/Card'
import Button from '../templates/ui/Button'
import { useCampaignStore } from '../app/store/campaignStore'
import './Landing.css'

export default function Landing() {
  const { state } = useCampaignStore()

  return (
    <section className="mobile-page landing-page mx-auto w-full max-w-md">
      <Card className="mobile-panel landing-card p-0">
        <div className="landing-header px-4 py-4 md:px-6">
          <p className="landing-badge">Big C Receipt Mutelu</p>
          <h1 className="landing-title mt-1 md:text-3xl">{state.campaign.campaignName}</h1>
          <p className="landing-subtitle mt-1">{state.campaign.tagline}</p>
        </div>

        <div className="landing-actions px-4 py-5 md:px-6">
          <Link to="/game/mutelu/scan" className="w-full flex justify-center">
            <Button className="landing-btn landing-btn-scan btn-uniform">
              สแกนบิลเช็คดวง
              <span className="landing-scan-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 4H5a1 1 0 0 0-1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M17 4h2a1 1 0 0 1 1 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M7 20H5a1 1 0 0 1-1-1v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M17 20h2a1 1 0 0 0 1-1v-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M6.5 12h11" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </span>
            </Button>
          </Link>
        </div>
      </Card>
    </section>
  )
}
